import { Box, Flex, Text } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { Trans } from '@lingui/macro'
import React from 'react'

import { useLogout } from 'front-end/src/public-api/hooks/useLogout'

import { useCreateNewSessionMutation } from './LogInAsUser.codegen'
import { UserSessionModelAsAdmin } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { getLoginLinkForSession } from './getLoginLinkForSession'
import { ButtonInfo } from 'front-end/src/components'

export const LogInAsUser: React.FC<{
  userId: number
}> = ({ userId }) => {
  const [
    createNewSession,
    { loading: loadingCreateNewSessionMutation, data: newSessionData }
  ] = useCreateNewSessionMutation()
  const logout = useLogout()

  const session = newSessionData?.admin?.user?.createSession
  const hrefForLogin =
    session && getLoginLinkForSession(session as UserSessionModelAsAdmin)

  return (
    <Flex mb={5} direction="column">
      <Box
        backgroundColor="rgba(255, 196, 2, 0.22)"
        p="12px"
        border={`1px solid  #b1bfc5`}
        borderRadius="4px"
      >
        <Box>
          <h3>
            <Trans>Log in as this user</Trans>
          </h3>
          <ButtonInfo
            isLoading={loadingCreateNewSessionMutation}
            onClick={async () => {
              await createNewSession({
                variables: {
                  userId
                }
              })
            }}
          >
            <Trans>Create a new session</Trans>
          </ButtonInfo>
          <Trans>This action will affect user's analytics</Trans>
        </Box>
        <br />
        {session && (
          <Flex>
            <a
              css={css`
                min-width: 192px;
              `}
              onClick={(ev) => {
                ev.preventDefault()
                logout(hrefForLogin!)

                return false
              }}
              href={hrefForLogin!}
            >
              <h2>
                <Trans>Login link</Trans>
              </h2>
            </a>

            <Text>
              <Trans>
                To open Looop as this user without losing your own session,
                right-click and open the link in an incognito window.
              </Trans>
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  )
}
